module.exports = __webpack_public_path__ + "static/media/cidadao.4f75cdc9.png";